import { useEffect, useState } from 'react';
import { getAdminReports } from '../../services/admin';
import styles from './Admin.module.css';

export function AdminReports() {
  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setLoading(true);
    const data = await getAdminReports();
    setReports(data);
    setLoading(false);
  };

  return (
    <div className={styles.adminPage}>
      <header className={styles.pageHeader}>
        <div>
          <h1>Diagnostic Reports</h1>
          <p>View and manage all system diagnostic reports generated by users.</p>
        </div>
      </header>

      <div className={styles.adminCard}>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center' }}>Loading reports...</div>
        ) : reports.length === 0 ? (
          <div style={{ padding: '60px 20px', textAlign: 'center' }}>
            <h2 style={{ marginBottom: '8px' }}>No Reports Found</h2>
            <p style={{ color: 'var(--text-3)' }}>No diagnostic reports have been generated on the platform yet.</p>
          </div>
        ) : (
          <div className={styles.tableWrapper}>
            <table className={styles.adminTable}>
              <thead>
                <tr>
                  <th>User Email</th>
                  <th>Category</th>
                  <th>Manufacturer</th>
                  <th>Score</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr key={report.id}>
                    <td>{report.userEmail || 'Anonymous'}</td>
                    <td>{report.category}</td>
                    <td>{report.manufacturer}</td>
                    <td>
                      <span className={styles.statusBadge} style={{ 
                        background: report.score > 80 ? 'rgba(57, 255, 20, 0.1)' : 'rgba(255, 165, 0, 0.1)',
                        color: report.score > 80 ? 'var(--accent)' : 'orange'
                      }}>
                        {report.score}/100
                      </span>
                    </td>
                    <td>{report.status || 'Completed'}</td>
                    <td>{report.createdAt?.toDate ? report.createdAt.toDate().toLocaleDateString() : 'N/A'}</td>
                    <td>
                      <button className={styles.actionBtn}>View Report</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
